import { render, staticRenderFns } from "./MyTodoForm.vue?vue&type=template&id=d72d0e1e&scoped=true&"
import script from "./MyTodoForm.vue?vue&type=script&lang=js&"
export * from "./MyTodoForm.vue?vue&type=script&lang=js&"
import style0 from "./MyTodoForm.vue?vue&type=style&index=0&id=d72d0e1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72d0e1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d72d0e1e')) {
      api.createRecord('d72d0e1e', component.options)
    } else {
      api.reload('d72d0e1e', component.options)
    }
    module.hot.accept("./MyTodoForm.vue?vue&type=template&id=d72d0e1e&scoped=true&", function () {
      api.rerender('d72d0e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BPMeletronicSigned/modules/MyTodoForm.vue"
export default component.exports